import React from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../helpers'
import {DrawerComponent} from '../../../assets/ts/components'
import {UiIcon} from '../../../../components/UiIcon'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  variant?: 'primary'
}

const AsideMenuItem: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  variant,
}) => {
  const {pathname} = useLocation()
  const path = pathname.replace(/\/+$/, '') || '/'
  const isActive = checkIsActive(path, to) ||
    (to === '/homework' && path.startsWith('/homework/') && path !== '/homework/create') ||
    (to === '/student' && (path.startsWith('/student/') || path === '/classroom/share')) ||
    (to === '/activities' && path.startsWith('/activities/')) ||
    (to === '/curriculum' && path.startsWith('/curriculum/') && path !== '/curriculum/0')
  const {config} = useLayout()
  const {aside} = config

  return (
    <div className={clsx('menu-item', {'aside-create': variant === 'primary'})}>
      <Link className={clsx('menu-link', {active: isActive})} to={to} aria-current={isActive ? 'page' : undefined}
        onClick={() => DrawerComponent.getInstance('kt_aside')?.hide()}>
        {fontIcon && <span className='menu-icon' aria-hidden='true'><UiIcon name={({ 'bi-grid': 'grid', 'bi-people': 'people', 'bi-plus-square': 'plus', 'bi-clock-history': 'history', 'bi-book': 'book', 'bi-journal-plus': 'book-add', 'bi-puzzle': 'activity' } as Record<string, string>)[fontIcon] || 'book'} /></span>}
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-5' svgClassName=' ' />
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
